import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import InActiveEmployees from "../Employee/InActiveEmployees.js";
import Pagination from '../../Pagination/Paginations.js';
import EntriesSelector from '../../Pagination/EntriesSelector';


// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';





const EmployeeControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;


	const [user, setUser] = useState({
        first_name: "",
        last_name: "",
        gender: "",
		date_of_joining: "",
		designation:"",
		floor:"",
		role:"",
		email:"",
		date_of_birth:"",
		password:"",
		confirm_password:"",
		contact_no:"",
		employee_type:"",
		address:"",
		// employee_shift:"",
		// contractor:"",
		// contractor_type:"",

    })

   
	//   const [gender, setGender] = useState("");
	  const [selectedDate, setSelectedDate] = useState(null);

    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });
    }


	const handelEmployeeShift=(event)=> {
		setEmployeeshift(event.target.value);
	}

	

	
	const history = useHistory();
	const [data, setData]= useState([]);
    const [dataval, setdataval]= useState([]);
	const [floorval, setfloorval]= useState([]);
	const [roleval, setroleval]= useState([]);
	const [settingval,setsettingval]=useState("");
	const [currentPageId, setCurrentPageId]= useState(1);



	

	
	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [entriesPerPage,setEntriesPerPage]=useState(10);
	// const [itemsPerPage, setItemsPerPage] = useState(25);
	// // const itemsPerPage = 10;
	// const indexOfLastItem = currentPage * itemsPerPage;
	// const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const filteredItems = data.filter((item) =>
	
		

	  `${item.employee_id.toLowerCase()}${item.first_name.toLowerCase()}${item.last_name.toLowerCase()}${item.department_name.toLowerCase()}${item.designation_name.toLowerCase()}${item.employee_shift.toLowerCase()}${item.is_active.toLowerCase()}`.includes(searchTerm.toLowerCase())
	 
	);



	const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
	// const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
	// const startIndex = (currentPage - 1) * itemsPerPage;
  
	// useEffect(() => {
	//   setCurrentPage(1);
	// }, [searchTerm]);
  
	// const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };


//   const handleRowsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1); // Reset to first page
//   };
  
	

	useEffect(()=> {
		axios.get(API_BASE_URL +'/showallemployee', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

	
		 .then(res => setData(res.data.user_det))
		//.then(res => console.log(res.data.user_det))
		.catch(err => console.log(err));
	},[])


	useEffect(()=> {
		axios.get(API_BASE_URL +'/showsetting', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

	
		.then(res => setsettingval(res.data.default_password))
		// .then(res => console.log(res.data.default_password))
		.catch(err => console.log(err));
	},[])


	

	// useEffect(() => {
	// 	handleUpdate();
	//   }, []);




	//   const recordsPerPage=50;

	//   const lastIndex=currentPage * recordsPerPage;
	//   const firstIndex= lastIndex - recordsPerPage;
	//   const records = data.slice(firstIndex, lastIndex);
	//   const npage = Math.ceil(data.length/ recordsPerPage);
	//   const numbers = [...Array(npage+1).keys()].slice(1);

	
	  const handleDepartment = async () => {

		axios.get(API_BASE_URL +'/showdepartment',  {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setdataval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleDepartment();
	  }, []);



	 
	




	  const handleFloor = async () => {

		axios.get(API_BASE_URL +'/showfloor',  {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setfloorval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleFloor();
	  }, []);


	  const handleRole = async () => {

		axios.get(API_BASE_URL +'/showrole', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setroleval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleRole();
	  }, []);


// 	const handleSubmit =async (e) => {

// 		e.preventDefault();
// 		axios.post(API_BASE_URL+'/addemployee', { first_name: user.first_name, last_name: user.last_name,gender: user.gender,date_of_joining: user.date_of_joining, department: department,designation: designation,floor: user.floor,role: user.role,email: user.email,date_of_birth: user.date_of_birth,password: user.password, confirm_password: user.password, contact_no: user.contact_no,employee_type: user.employee_type,employee_shift: user.employee_shift,address: user.address }, {
// 			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
// 		}).then(response => {
// 			console.log(response.data);
// 			console.log(response.data.message);
// 		})
			
	
// };


const handleSubmit = async (e) => {

	e.preventDefault();
   

	// setError(null);
	// setLoading(true);
	// e.preventDefault();
	axios.post(API_BASE_URL+'/addemployee', { first_name: user.first_name, last_name: user.last_name,gender: user.gender,date_of_joining: user.date_of_joining, department_id: department,designation_id: designation,floor_id: user.floor,role: user.role,email: user.email,date_of_birth: user.date_of_birth,password: settingval, confirm_password: settingval, contact_no: contact_no,emp_type: user.employee_type,employee_shift: employee_shift,address: user.address,contractor_id:contractor,employeetype_id:contractortype}, {
					headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
				}).then(response => {
		// 	console.log(response.data);
		// 	console.log(response.data.message);
		// })

		var status = response.data.status;
		var id=response.data.insert_id;

		if (status == 200) {
			toast.success(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});


			const timeout = setTimeout(() => {
				window.location.href = "employees-detail?id="+id;
				// window.location.reload(); // Reload the current page
			}, 5000); // Refresh after 5 seconds

			return () => {
				clearTimeout(timeout); // Cleanup the timeout if the component unmounts
			};

		} else if(status == 401) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}
		else if (status == 400) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}


	}).catch(error => {
		// console.log(error);
		// console.log(error.response.data.message);




		toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",


		});

	});
};


 const [toggle,setToggle]=useState(false);
 const clearInput = () => {
	setSearchTerm("");
  };


 const [department, setDepartmentValue] = useState("");
 const [designationDropdownOptions,setDesignationDropdownOptions]=useState([]);
 const [designation,setDesignationValue] = useState("");
 const [contact_no, setNumValue] = useState("");
 //const [firstDropdownValue, setFirstDropdownValue] = useState("");
//   const [secondDropdownOptions, setSecondDropdownOptions] = useState([]);
//   const [secondDropdownValue, setSecondDropdownValue] = useState("");

  // Handle first dropdown change
  const handleFirstDropdownChange = (event) => {
    const value = event.target.value;
    setDepartmentValue(value);

    // Trigger API call based on the selected value
    fetchSecondDropdownOptions(value);
  };



   // Fetch options for the second dropdown
   const fetchSecondDropdownOptions = async (selectedValue) => {
    try {
    
	const response = await fetch(
        API_BASE_URL + '/showdesignationcheck/'+selectedValue,  {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
      ); // Replace with your API URL

      const data = await response.json();
      setDesignationDropdownOptions(data); // Assuming the API returns an array of options
    } catch (error) {
      console.error("Error fetching second dropdown options:", error);
    }
  };

    // Handle second dropdown change
	const handleSecondDropdownChange = (event) => {
		// setSecondDropdownValue(event.target.value);
		setDesignationValue(event.target.value);
	  };


	  const handelNumber = (e) => {
		const inputValue = e.target.value;
	
		// Allow only numeric characters
		if (/^\d*$/.test(inputValue)) {
			setNumValue(inputValue);
		}
	  };



	  const [employee_shift,setEmployeeshift]= useState("");
	  const [contractordata,setContractorData]= useState([]);
	  const [contractor,setContractorValue]= useState("");
	  const [contractotypeDropdownOptions,setContractorTypeDropdownOptions]= useState([]);
	  const [contractortype,setContractorTypeValue]= useState("");
	  const [shiftemployee,setShiftEmployee]=useState("");


	  const handleContractor = async () => {

		axios.get(API_BASE_URL +'/showcontractor',  {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setContractorData(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleContractor();
	  }, []);



	  const handleContractorDropdownChange = (event) => {
		const value = event.target.value;
		setContractorValue(value);
	
		// Trigger API call based on the selected value
		fetchContractorTypeDropdownOptions(value);
	  };
	
	
	
	//    Fetch options for the second dropdown
	   const fetchContractorTypeDropdownOptions = async (selectedValue) => {
		try {
		
		const response = await fetch(
			API_BASE_URL + '/showcontractortype/'+selectedValue
		  ); // Replace with your API URL
	
		  const data = await response.json();
		  setContractorTypeDropdownOptions(data); // Assuming the API returns an array of options
		} catch (error) {
		  console.error("Error fetching second dropdown options:", error);
		}
	  };
	
		// Handle second dropdown change
		const handleContractorTypeDropdownChange = (event) => {
			// setSecondDropdownValue(event.target.value);
			setContractorTypeValue(event.target.value);
		  };


		  const handelShiftEmployee = (event) => {

			setEmployeeshift(event.target.value);
	
			// if (event.target.value === '1') {
			// 	setIsVisible(true);
			// } else {
			// 	setIsVisible(false);
			// }
		}


		const [isYes, setIsYes] = useState(true);


		// const options = [
		// 			{ value: "apple", label: "Apple" },
		// 			{ value: "banana", label: "Banana" },
		// 			{ value: "orange", label: "Orange" },
		// 		  ];
		
		// 		  const handleChange = (selected) => {
		// 			setSelectedOption(selected);
		// 		  };
		
		// 		  const [selectedOption, setSelectedOption] = useState();

	

	return (
		<>

		
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							{/* <div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action">
								<div id="button">
									<button style={{float: 'center'}}
										type="button"
										className="btn btn-primary"
										data-toggle="modal"
										data-target="#exampleModal"
									>
										<i className="fe fe-plus mr-2" />
										Add 
									</button>
								</div>
								</div>
							</div> */}

						</div>
					</div>


{/* 
					<div>
      <h3>React-Select Dropdown</h3>
      <Select
        options={options}
        value={selectedOption} // Set default selected value
        onChange={handleChange} // Handle selection change
        isSearchable={true} // Enable search
        placeholder=""
      />
      {selectedOption && <p>Selected: {selectedOption.label}</p>}
    </div> */}
									
                    
								
					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">

								
								
							
									
								
							   
								
                               


								<button style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
										type="button"
										className="btn btn-primary"
										onClick={()=>setToggle(!toggle)}
									>
										<i className="fe fe-plus mr-2" />
										Add
									</button>

							

							

							
								
								{toggle && (	

<div className="card">
								
							
<div className="card-header">
	
{/* <div className="section-body mt-3"> */}

					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title" style={{color:'#e96827',fontWeight: 600}}>Add Employee</h3>
									</div>
									<div className="card-body">
										<form onSubmit={handleSubmit}>

                                            <div class="row">

										

											<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">First Name <span className="form-required">*</span></label>
				<input
					type="text"
					className="form-control" name="first_name" value={user.first_name} onChange={handelInput}
					placeholder="First Name *"
				/>
			</div>
		</div>
		<div className="col-md-3 col-sm-12">   
			<div className="form-group"> 
			<label className="form-label">Last Name <span className="form-required">*</span></label>
				<input
					type="text"
					className="form-control"
					placeholder="Last Name" name="last_name" value={user.last_name} onChange={handelInput}
				/>
			</div>
		</div>

		<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Gender <span className="form-required">*</span></label>
				<select className="form-control show-tick" name="gender" value={user.gender} onChange={handelInput}>
					<option>Select Gender</option>
					<option value="Male">Male</option>
					<option value="FeMale">Female</option>
					
				</select>
			</div>
		</div>

	<div className="col-md-3 col-sm-12">
	<label className="form-label">Date Of Joining <span className="form-required">*</span></label>
		<div className="form-group">

		<input type="date" className="form-control" name="date_of_joining" value={user.date_of_joining}
								onChange={handelInput} placeholder="Select Date of Joining" />
		{/* <DatePicker
        selected={selectedDate}
		value={user.date_of_joining}
		onChange={handelInput}
        //onChange={(date) => setSelectedDate(date)}
        dateFormat="yyyy-MM-dd"
        isClearable
        placeholderText="Date Of Joining"
      /> */}
	  {/* {selectedDate && <p>Selected Date: {selectedDate.toDateString()}</p>} */}
		</div>
	</div>

		<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Department <span className="form-required">*</span></label>

			<select className="form-control show-tick" name="department"  isSearchable={true} // Enable search
        placeholder="Select a fruit..." value={department}  onChange={handleFirstDropdownChange}>
			<option>Select Department</option>
				{dataval.map(option => (
				<option key={option.department_id} value={option.department_id}>
				{option.department_name}
				</option>
				))}
        </select>
				{/* <select className="form-control show-tick" name="department" value={user.department} onChange={handleFirstDropdownChange}>
					<option>Select Department</option>

					{dataval.map(option => (
					<option key={option.department_id} value={option.department_id}>
					{option.department_name}
					</option>
					))}
				</select> */}
			</div>
		</div>

		<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Designation <span className="form-required">*</span></label>
			<select className="form-control show-tick"
          value={designation} name="designation"
          onChange={handleSecondDropdownChange}
          disabled={designationDropdownOptions.length === 0}
        >
          <option value="">Select Designation</option>
          {designationDropdownOptions.map((option) => (
            <option key={option.designation_id} value={option.designation_id}>
              {option.designation_name}
            </option>
          ))}
        </select>
			</div>
		</div>


		<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Floor <span className="form-required">*</span></label>

			<select className="form-control show-tick" name="floor" value={user.floor} onChange={handelInput}>
			<option>Select Floor</option>
				{floorval.map(option => (
				<option key={option.floor_id} value={option.floor_id}>
				{option.floor_name}
				</option>
				))}
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Role <span className="form-required">*</span></label>

			<select className="form-control show-tick" name="role" value={user.role} onChange={handelInput}>
			<option>Select Role</option>
				{roleval.map(option => (
				<option key={option.role_id} value={option.role_id}>
				{option.role_name}
				</option>
				))}
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">   
			<div className="form-group"> 
			<label className="form-label">Email <span className="form-required">*</span></label>
				<input
					type="text"
					className="form-control"
					placeholder="Email" name="email" value={user.email} onChange={handelInput}
				/>
			</div>
		</div>


		<div className="col-md-3 col-sm-12">
			<label className="form-label">Date Of Birth <span className="form-required">*</span></label>
			<div className="form-group">

			<input type="date" className="form-control" name="date_of_birth" value={user.date_of_birth}
								onChange={handelInput} placeholder="Select Date of Birth" />
			</div>
	</div>
	


		<div className="col-md-3 col-sm-12">   
			<div className="form-group"> 
			<label className="form-label">Password <span className="form-required">*</span></label>
				<input
					type="text"
					className="form-control"
					placeholder="Password" name="password" value={settingval} onChange={handelInput}
					disabled />
			</div>
		</div>

		<div className="col-md-3 col-sm-12">   
			<div className="form-group"> 
			<label className="form-label">Confirm Password <span className="form-required">*</span></label>
				<input
					type="text"
					className="form-control"
					placeholder="Confirm Password" name="confirm_password" value={settingval} onChange={handelInput}
				disabled/>
			</div>
		</div>


		<div className="col-md-3 col-sm-12">   
			<div className="form-group"> 
			<label className="form-label">Contact Number <span className="form-required">*</span></label>
				<input
					type="text"
					className="form-control"
					placeholder="Contact Number" name="contact_no" value={contact_no} onChange={handelNumber}  maxlength="10" 
				/>
			</div>
		</div>


		<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Employee Type <span className="form-required">*</span></label>

			<select className="form-control show-tick" name="employee_type" value={user.employee_type} onChange={handelInput}>
			<option value="">EmployteeType</option>
			<option value="1">Regular Employee</option>
            <option value="2">Doctor</option>
            <option value="3">House keeping</option>
            <option value="4">Security</option>
            <option value="5">Canteen</option>
            <option value="6">Intern Students</option>
				
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Employee Shift <span className="form-required">*</span></label>

			<select className="form-control show-tick" name="employee_shift" value={employee_shift} onChange={handelShiftEmployee}>
			<option value="">Select Employee Shift</option>
			<option value="1">Normal Shift</option>
            <option value="2">Nearby Shift</option>
        </select>
		</div>
       </div>

       


	


	   <div className="col-md-6 col-sm-12">
			<div className="form-group">
			<label className="form-label">Address</label>

			<textarea
			id="textarea"
			name="address"
			value={user.address} // Bind the value to state
			onChange={handelInput} // Update state on change
			placeholder=""
			rows="4" // Number of rows (optional)
			cols="35" // Number of columns (optional)
		></textarea>
		
		</div>
       </div>


	   {employee_shift==2 && (
		
		<div className="col-md-3 col-sm-12">
			 <div className="form-group">
			 <label className="form-label">Contractor <span className="form-required">*</span></label>
 
			 <select className="form-control show-tick" name="contractor" value={contractor} onChange={handleContractorDropdownChange} >
			 <option value="">Select Contractor</option>
				 {contractordata.map(option => (
				 <option key={option.id} value={option.id}>
				 {option.contractor_name}
				 </option>
				 ))}
		 </select>
				 
			 </div>
		 </div>
		)}



	   {employee_shift==2 && (
		<div className="col-md-3 col-sm-12">   
			<div className="form-group">
			<label className="form-label">Contractor Type <span className="form-required">*</span></label>
			<select className="form-control show-tick"
          value={contractortype} name="contratortype"
          onChange={handleContractorTypeDropdownChange}
          disabled={contractotypeDropdownOptions.length === 0}
        >
          <option value="">Select Designation</option>
          {contractotypeDropdownOptions.map((option) => (
            <option key={option.contractor_type_id} value={option.contractor_type_id}>
              {option.role_name}
            </option>
          ))}
        </select>
			</div>
		</div>

)}
	

	   </div>

	   <div class="row">

	   <div className="form-footer">
            <button className="btn btn-primary btn-block">Save</button>
       </div>
	   </div>

	  

		{/* <div className="col-md-3 col-sm-12">
			<div className="form-group">
				<input
					type="text"
					className="form-control"
					placeholder="Email ID *"
				/>
			</div>
		</div> */}



      

                               

                                           


										
	
										
											
										</form>
									</div>
								</div>

								
							</div>

						</div>
					</div>
				{/* </div> */}




                             
</div>
</div>
                            
                           

)}



</div>
                            </div>
                        </div>
                    </div>

					<div className="card-header">
									<div className="form-group">
                                            {/* <div className="form-label">Toggle switch single</div> */}
                                            <label className="custom-switch">
                                                <input type="checkbox" name="custom-switch-checkbox" className="custom-switch-input" defaultChecked  onClick={() => setIsYes(!isYes)} />
                                                <span className="custom-switch-indicator" />
                                                <span className="custom-switch-description" style={{ fontSize: "12px" }}>{isYes ? "Active Employees" : "InActive Employees"}</span>
                                            </label>
                                        </div>
									</div>

                <div>
					{isYes
                    ? 

					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
									
								

									
                                    
										<div className="card-header">

										<div className="card-header">
                                              <h3 className="card-title" style={{color:'#e96827',alignItems: 'right',fontSize:'12px'}}>Employee List</h3>
                                             </div>
											
											<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>
												
											


													<div className="input-group">

														<EntriesSelector 
        setEntriesPerPage={setEntriesPerPage}
        setCurrentPage={setCurrentPage}
      />

												
													
													<div style={{ position: "relative", width: "250px" }}>

													<input
															type="text"
															className="form-control form-control-sm"
															placeholder="Search"
															value={searchTerm}
															onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}} 
															style={{
																width: "100%",
																padding: "5px 0px 4px 0px",
																paddingRight: "30px", // Extra space for the clear icon
																boxSizing: "border-box",
															  }} 
														/>


{searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
			top: "50%",
			right:"10px",
			transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
			// marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
													</div>
														


														
													</div>
												
											</div>
										</div>


										
										


										

										



										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
                                                            <th>Action</th>
															<th>ID</th>
															<th>Name</th>
															<th>Department</th>
															<th>Designation</th>
															<th>Employee Type</th> 
                                                            <th>Status</th>
															
														</tr>
													</thead>
													<tbody>



                                                    

													

                                                        {
                                                            filteredData.map((emp,index) => {

                                                        return <tr key={index}>
                                                            <td className="d-flex">
                                                            <Link to={`/employees-detail?id=${emp.user_id}`}>
                                                                <i className="fe fe-maximize" />
                                                            </Link>
                                                                
                                                            </td>
                                                            <td>
																<span>{emp.employee_id}</span>
															</td>
															<td>
																<span>{emp.first_name} {emp.last_name}</span>
															</td>
															<td>
																<span>{emp.department_name}</span>
															</td>
                                                            <td>
																<span>{emp.designation_name}</span>
															</td>
                                                            <td>
                                                            <span className="tag" style={{backgroundColor:"#2760fb",color:"white"}}>{emp.employee_shift}</span>
															</td>
                                                            <td>
																<span>{emp.is_active}</span>
															</td>
                                                        </tr>


                                                        })
                                                        }

														
													</tbody>
												</table>
											</div>

											

									

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />













									


										</div> 
									</div>
								</div>
	
							
							</div>
						</div>
					</div>
					: <InActiveEmployees></InActiveEmployees>

		}
					</div>


				</div>
			</div>



			

							

			

			


			

		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeControl);